import React, { Component, ChangeEvent } from 'react';
import './styles.scss';
import { getImage, api } from '../../utils';
import { AppContext } from '../../Context';
import {
	ALL_ACTIONS,
	MAX_FILE_UPLOAD_SIZE_LIMIT_IN_BYTES,
	MIME_TYPE_TO_FILE_EXTENSION_MAPPING,
} from '../../constants';
import Modal from '../Modal';
import Button from '../Button';
// import JitsiMeeting from '@jitsi/react-sdk';
// import { timingSafeEqual } from 'crypto';

type Props = {
	onSearch?: Function;
	onEnter?: Function;
	onFileUploadSuccess?: Function;
	placeholder: string;
	updateFileUploadStatus?: Function;
	icon?: string;
	value?: string;
	importedImg?: string;
	serchText?: Function;
	src?: string;
	sessionID?: any;
	showFileUploadIcon?: boolean;
	channel?: any;
	deviceInfo?: any;
	phoneNumber?: any;
	time?: any;
	botId?: any;
	queue?: any;
	onInput?: Function;
	closeFileUploadStatus?: Function;
};
type State = {
	searchTerm: string;
	isFileUploadDisabled: boolean;
	isFileUploadValidationModalOpen: boolean;
	isFileType: boolean;
	showMessage: string;
	showTitle: string;
	onCall: boolean;
};

class SearchBar extends Component<Props, State> {
	static contextType = AppContext;
	constructor(props: Props) {
		super(props);
		this.state = {
			searchTerm: '',
			isFileUploadDisabled: false,
			isFileUploadValidationModalOpen: false,
			isFileType: false,
			showMessage: '',
			showTitle: '',
			onCall: false,
		};

		this.handleFileUpload = this.handleFileUpload.bind(this);
		this.handleCloseModal = this.handleCloseModal.bind(this);
	}

	componentDidUpdate(prevProps: Props) {
		if (this.props.value !== prevProps.value) {
			this.setState({
				searchTerm: this.props.value || '',
			});
		}
	}

	handleSearch(event: ChangeEvent<HTMLInputElement>) {
		// @ts-ignoreignore
		var term = event.target.value;
		// console.log(event.target);
		this.setState({
			searchTerm: term,
		});
		this.props.onSearch && this.props.onSearch(term);
		this.props.serchText && this.props.serchText(term);
	}

	clearContextValue() {
		if (this.props.value) {
			this.context.dispatch({
				type: ALL_ACTIONS.UPDATE_INPUT_STATE,
				payload: '',
			});
		}
	}

	onEnter() {
		if (this.props.onEnter && this.state.searchTerm) {
			this.props.onEnter(this.state.searchTerm);
			this.setState({
				searchTerm: '',
			});
			this.clearContextValue();
		}
	}
	// onInput() {}
	handleFileUpload(e: ChangeEvent) {
		this.setState({
			isFileUploadDisabled: true,
		});
		try {
			const files = (e.target as HTMLInputElement).files;

			if (files && files[0]) {
				const file = files[0];
				const name = file.name;
				const size = file.size;
				const type = file.type;
				let checktype = MIME_TYPE_TO_FILE_EXTENSION_MAPPING[type];
				// file size validation
				if (size > MAX_FILE_UPLOAD_SIZE_LIMIT_IN_BYTES) {
					this.setState({
						isFileUploadValidationModalOpen: true,
						showMessage: 'File size should not exceed 5 MB',
						showTitle: 'Unable to send file',
						isFileUploadDisabled: false,
					});
				} else if (checktype === undefined || checktype === null) {
					this.setState({
						// isFileType: true,
						isFileUploadValidationModalOpen: true,
						showMessage: 'Please try again',
						showTitle: "couldn't upload your file",
						isFileUploadDisabled: false,
					});
				} else {
					if (this.props.updateFileUploadStatus) {
						this.props.updateFileUploadStatus(this.props.sessionID, name, 1);
					}
					const fd = new FormData();
					fd.append('fileToUpload', file);
					fd.append('phoneNumber', this.props.phoneNumber);
					fd.append('sessionId', this.props.sessionID);
					fd.append('botId', this.props.botId);
					fd.append('time', this.props.time);
					fd.append('queue', this.props.queue);
					fd.append('channel', this.props.channel);
					fd.append('deviceInfo', this.props.deviceInfo);

					api('upload', 'POST', fd, undefined, 'file')
						.then((res) => {
							if (this.props.updateFileUploadStatus) {
								this.props.updateFileUploadStatus(
									this.props.sessionID,
									name,
									2
								);
							}
							this.setState({
								isFileUploadDisabled: false,
							});
							if (res.result === 'success') {
								// if(type==undefined){
								//   this.setState({
								//     isFileType:true
								//   })
								// }
								if (this.props.onFileUploadSuccess) {
									this.props.onFileUploadSuccess(
										name,
										size,
										type,
										res.mediaURL,
										res.sessionId,
										res.time,
										res.channel,
										res.deviceInfo,
										res.phoneNumber,
										res.botId,
										res.queue
									);
								}
								setTimeout(() => {
									if (this.props.closeFileUploadStatus) {
										this.props.closeFileUploadStatus(res.sessionId);
									}
								}, 3000);
							} else {
								if (this.props.updateFileUploadStatus) {
									this.props.updateFileUploadStatus(
										this.props.sessionID,
										name,
										3
									);
								}
							}
						})
						.catch((error) => {
							if (this.props.updateFileUploadStatus) {
								this.props.updateFileUploadStatus(
									this.props.sessionID,
									name,
									3
								);
							}
							this.setState({
								isFileUploadDisabled: false,
							});
							console.error(error);
						});
				}
			}
		} catch (e) {
			console.error(e);
		}
	}

	handleCloseModal() {
		this.setState({
			isFileUploadValidationModalOpen: false,
		});
	}

	handleErrorCloseModal() {
		this.setState({
			isFileType: true,
		});
	}

	render() {
		return (
			<>
				<div
					className={`search ${
						this.props.src === 'teamtab' ? 'search-border' : ''
					}`}
					onKeyPress={(event) => {
						if (event.key === 'Enter') {
							this.onEnter();
						}
					}}
					style={
						this.props.placeholder === 'Send a message'
							? { border: 'none' }
							: {}
					}>
					<input
						autoFocus={true}
						type='text'
						className='form-control'
						id='search'
						placeholder={this.props.placeholder}
						value={this.state.searchTerm}
						onClick={(event) => {
							event.stopPropagation();
						}}
						autoComplete='off'
						onChange={(event) => {
							event.stopPropagation();
							this.handleSearch(event);
						}}
						style={
							this.props.placeholder === 'Send a message'
								? {
										border: 'none',
										width: 'calc(100% - 13%)',
										fontFamily: 'OpenSans',
								  }
								: { border: 'none', fontFamily: 'OpenSans' }
						}
					/>

					{/* {this.state.onCall ? (
            <JitsiMeeting domain={'YOUR_DOMAIN'} roomName={'h123'} />
          ) : (
            <div
              className='video-call'
              onClick={() => {
                this.setState({
                  onCall: true,
                });
              }}>
              <img src='' alt='video' />
            </div>
          )} */}

					<div className='input-submit-section'>
						{/* {this.props.showFileUploadIcon ? (
              <div
                id='__fileupload_icon__'
                className='icon'
                style={
                  this.state.isFileUploadDisabled
                    ? { cursor: 'not-allowed' }
                    : { cursor: 'pointer' }
                }>
                <input
                  type='file'
                  id='__media_file__'
                  title={
                    this.state.isFileUploadDisabled
                      ? 'Please wait for the current file to finish uploading.'
                      : ''
                  }
                  style={
                    this.state.isFileUploadDisabled
                      ? { cursor: 'not-allowed' }
                      : { cursor: 'pointer' }
                  }
                  onChange={this.handleFileUpload}
                  // disabled={this.state.isFileUploadDisabled}
                />
              </div>
            ) : (
              <></>
            )} */}
						{this.props.importedImg ? (
							<img
								src={this.props.icon}
								alt={this.props.icon}
								onClick={() => {
									this.onEnter();
								}}
								style={
									this.props.placeholder === 'Send a message'
										? { width: '24px', height: '24px' }
										: {}
								}
							/>
						) : this.props.icon === 'submit' ? (
							<div
								id='__submit_icon__'
								className='icon'
								onClick={() => {
									this.onEnter();
								}}></div>
						) : (
							<img
								src={getImage(`${this.props.icon}.svg`)}
								alt={this.props.icon}
								onClick={() => {
									this.onEnter();
								}}
								style={
									this.props.placeholder === 'Send a message'
										? { width: '24px', height: '24px' }
										: {}
								}
							/>
						)}
					</div>
				</div>
				<Modal
					isOpen={this.state.isFileUploadValidationModalOpen}
					title={this.state.showTitle}
					showBorders='true'
					source='general-tab'
					onClose={this.handleCloseModal}>
					<div className='file-upload-validation-modal-content-text'>
						{/* File size should not exceed 5 MB */}
						{this.state.showMessage}
					</div>
					<div className='file-upload-validation-modal-action-area'>
						<Button
							text='Cancel'
							theme='secondary-blue'
							onClick={this.handleCloseModal}
						/>
					</div>
				</Modal>
				{/* <Modal
          isOpen={this.state.isFileType}
          title='Unable to send file'
          showBorders='true'
          onClose={this.handleErrorCloseModal}>
          <div className='file-upload-validation-modal-content-text'>
            Couldn't upload your file
          </div>
          <div className='file-upload-validation-modal-action-area'>
            <Button
              text='Cancel'
              theme='secondary-blue'
              onClick={this.handleErrorCloseModal}
            />
          </div>
        </Modal> */}
			</>
		);
	}
}

export default SearchBar;
